<template>
  <div>
    <!-- Start: Banner -->
    <section class="flight">
      <div class="jumbotron jumbo-sm">
        <!-- <div
        class="jumbotron jumbo-sm"
        :style="{
          'background-image': `url(${cdn}/images/template-inventory.jpg)`,
          'background-position': 'right bottom',
        }"
      >       -->
        <div class="get-search">
          <div class="container">
            <div class="cBet">
              <div class="search__result-header">
                <div class="flight-route big-text">
                  <div>From <span>&bull;</span> {{ pickUpLocation }}</div>
                </div>
                <div class="get-passenger-info">
                  <div>
                    {{ longStartRentDate }} <span>&bull;</span>
                    {{ shortStartRentTime }} {{ pickUpDateTime.offsetName }}
                    <span v-if="transferDistance">&bull;</span>
                    {{ transferDistance }}
                  </div>
                </div>
              </div>
              <button
                class="btn btn--white mr-15"
                @click="onClickModifySearch()"
              >
                Modify Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Banner -->

    <!-- Start: Content -->
    <section class="car__search-result">
      <div class="container">
        <div class="row">
          <!-- Start: Filter -->
          <div class="col-sm-3 prz">
            <!-- Start: Skeleton filter -->
            <div v-if="isLoading">
              <div class="filter-box--left">
                <div class="filter-box--header">
                  <div
                    class="loader-list--lines shine big-title pull-left"
                  ></div>
                  <div
                    class="loader-list--circle shine big-title pull-right"
                  ></div>
                </div>
                <div class="car-specification mb-20">
                  <div class="loader-list--lines shine big-title"></div>
                  <div class="loader-list--lines shine --small"></div>
                  <div class="loader-list--lines shine --small"></div>
                  <div class="loader-list--lines shine --small"></div>
                  <div class="loader-list--lines shine --small"></div>
                  <div class="loader-list--lines shine --small"></div>
                </div>
                <div class="car-specification mb-20">
                  <div class="loader-list--lines shine big-title"></div>
                  <div class="loader-list--lines shine --small"></div>
                  <div class="loader-list--lines shine --small"></div>
                  <div class="loader-list--lines shine --small"></div>
                  <div class="loader-list--lines shine --small"></div>
                </div>
                <div class="car-specification mb-20">
                  <div class="loader-list--lines shine big-title"></div>
                  <div class="loader-list--lines shine --small"></div>
                  <div class="loader-list--lines shine --small"></div>
                  <div class="loader-list--lines shine --small"></div>
                  <div class="loader-list--lines shine --small"></div>
                </div>
                <div class="car-specification mb-20">
                  <div class="loader-list--lines shine big-title"></div>
                  <div class="loader-list--lines shine --small"></div>
                  <div class="loader-list--lines shine --small"></div>
                </div>
              </div>
            </div>
            <!-- End: Skeleton filter -->

            <div v-if="!isLoading && countVehicle">
              <div class="filter-box--left">
                <div class="filter-box--header">
                  <i class="ic-settings-horizontal"></i> Filter
                  <a class="reset-button" @click="onClickFilterReset()"
                    >Reset</a
                  >
                </div>
                <div class="car-specification">
                  <div
                    class="form-group"
                    v-if="filter.classes && filter.classes.length > 0"
                  >
                    <div class="group-filter">
                      <header>
                        <button class="btn btn-block">
                          Class <i class="ic-chevron-up"></i>
                        </button>
                      </header>
                      <div class="btn-group-checkbox">
                        <label
                          class="cursor-pointer d-block w-max-content"
                          v-for="(item, index) in filter.classes"
                          :key="index"
                        >
                          <input
                            type="checkbox"
                            class="control-checkbox"
                            v-model="item.isSelected"
                            @change="onChangeApplyFilter(item, 'classes')"
                          />
                          <span
                            class="pl-5 font-weight-normal v-align-middle text-filter"
                          >
                            {{ item.text }}
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    v-if="filter.specs && filter.specs.length > 0"
                  >
                    <div class="group-filter">
                      <header>
                        <button class="btn btn-block">
                          Car Specification <i class="ic-chevron-up"></i>
                        </button>
                      </header>
                      <div class="btn-group-checkbox">
                        <label
                          class="cursor-pointer d-block w-max-content"
                          v-for="(item, index) in filter.specs"
                          :key="index"
                        >
                          <input
                            type="checkbox"
                            class="control-checkbox"
                            v-model="item.isSelected"
                            @change="onChangeApplyFilter(item, 'specs')"
                          />
                          <span
                            class="pl-5 font-weight-normal v-align-middle text-filter"
                          >
                            {{ item.text }}
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    v-if="filter.brands && filter.brands.length > 0"
                  >
                    <div class="group-filter">
                      <header>
                        <button class="btn btn-block">
                          Brand <i class="ic-chevron-up"></i>
                        </button>
                      </header>
                      <div class="btn-group-checkbox">
                        <label
                          class="cursor-pointer d-block w-max-content"
                          v-for="(item, index) in filter.brands"
                          :key="index"
                        >
                          <input
                            type="checkbox"
                            class="control-checkbox"
                            v-model="item.isSelected"
                            @change="onChangeApplyFilter(item, 'brands')"
                          />
                          <span
                            class="pl-5 font-weight-normal v-align-middle text-filter"
                          >
                            {{ item.text }}
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="filter-box--left hidden"
                v-if="filter.sort && filter.sort.length > 0"
              >
                <div class="filter-box--header">
                  <i class="ic-filter"></i> Sort
                </div>
                <div class="form-group">
                  <div class="btn-group-radio">
                    <label
                      class="wrap-radio"
                      v-for="(item, index) in filter.sort"
                      :key="index"
                    >
                      <span>{{ item.text }}</span>
                      <input
                        type="radio"
                        name="sortPrice"
                        :value="item.value"
                        :checked="filter.defaultSort === item.value"
                        v-model="filter.defaultSort"
                        @click="onClickApplySort(item)"
                      />
                      <span class="bullet-mark"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End: Filter -->

          <div class="col-sm-9">
            <!-- Start: Widget -->
            <div class="car-result-header">
              <div class="row cRow" v-if="!isLoading && countVehicle">
                <div class="col-sm-6">
                  <strong v-if="isLoading" style="color: #fff"></strong>
                  <div class="flex-column" v-else>
                    <strong class="--blue25">
                      {{ countVehicle }} Transportation(s) available
                    </strong>
                  </div>
                </div>
                <div
                  class="col-sm-6"
                  v-if="filter.sort && filter.sort.length > 0"
                >
                  <div class="row cRow">
                    <div class="col-sm-3 prz">
                      <div class="filter-box--header pull-right pz">
                        <i class="ic-filter hidden"></i>Sort by:
                      </div>
                    </div>
                    <div class="col-sm-9 text-center pz">
                      <div class="form-group mbz">
                        <div class="btn-group-radio">
                          <label
                            class="wrap-radio"
                            v-for="(item, index) in filter.sort"
                            :key="index"
                          >
                            <span>{{ item.text }}</span>
                            <input
                              type="radio"
                              name="sortPrice"
                              :value="item.value"
                              :checked="filter.defaultSort === item.value"
                              v-model="filter.defaultSort"
                              @click="onClickApplySort(item)"
                            />
                            <span class="bullet-mark"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- /.cRow -->
                </div>
              </div>
              <div class="row cRow" v-if="!isLoading && countVehicle">
                <div class="col-sm-12">
                  <ul>
                    <li class="li-info-availability">
                      <span class="text-12 --grey45"
                        >All Includes Fuel, Toll and Parking</span
                      >
                    </li>
                    <li class="li-info-availability">
                      <span class="text-12 --grey45"
                        >Rates are not applicable to major events, festivals and
                        concerts. Please contact
                        <a
                          class="availability-link"
                          target="_blank"
                          href="mailto:support@trranster.com"
                          >support@trranster.com</a
                        >
                        for special event quotes.</span
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- End: Widget -->

            <!-- Start: Availability -->
            <div class="car-result">
              <!-- Start: Loader -->
              <ul v-if="isLoading" class="c-list">
                <div class="loader-list" v-for="index in 4" :key="index">
                  <div class="row">
                    <div class="col-sm-4">
                      <div class="loader-list--image shine"></div>
                    </div>
                    <div class="col-sm-4 plz">
                      <div class="loader-list--lines shine big-title"></div>
                      <div class="loader-list--lines shine"></div>
                      <div class="loader-list--lines shine"></div>
                      <div class="loader-list--lines shine"></div>
                    </div>
                    <div class="col-sm-4">
                      <div
                        class="loader-list--lines shine big-title pull-right"
                      ></div>
                    </div>
                  </div>
                  <!-- /.row -->
                  <div class="row hidden">
                    <div class="col-sm-1">
                      <div class="loader-list--circle shine"></div>
                    </div>
                    <div class="col-sm-4">
                      <div class="loader-list--lines shine"></div>
                      <div class="loader-list--lines shine"></div>
                    </div>
                  </div>
                  <!-- /.row -->
                </div>
              </ul>
              <!-- End: Loader -->

              <!-- Start: Vehicle -->
              <ul v-if="!isLoading && countVehicle" class="c-list">
                <li v-for="(item, index) in items" :key="index">
                  <div class="wrap__select-list">
                    <div class="header-box cars">
                      <div class="col-sm-8 pz cRow">
                        <div class="col-sm-4 pz">
                          <img :src="item.imageUri" class="cars-image" alt />
                        </div>
                        <div class="col-sm-8 pl-20">
                          <div class="cars-brand">{{ item.className }}</div>
                          <div
                            class="model-car"
                            v-if="
                              item.factoryName !== null ||
                              item.brandName !== null
                            "
                          >
                            <span
                              >{{ item.factoryName }} {{ item.brandName }}</span
                            >
                          </div>
                          <div
                            class="capacity-seat"
                            v-if="item.feature && item.feature.paxCapacity > 0"
                          >
                            Max. Passenger {{ item.feature.paxCapacity }}
                          </div>
                          <!-- <div
                            class="capacity-large-baggage"
                            v-if="item.feature && item.feature.largeBaggageCapacity > 0"
                          >
                            Large Bag. x{{ item.feature.largeBaggageCapacity }}
                          </div>
                          <div
                            class="capacity-baggage"
                            v-if="item.feature && item.feature.smallBaggageCapacity > 0"
                          >
                            Small Bag. x{{ item.feature.smallBaggageCapacity }}
                          </div> -->
                        </div>
                      </div>
                      <div class="col-sm-4 prz">
                        <div class="cars__info-3 text-right">
                          <div>
                            <!-- <div class="label-price">Total Price</div> -->
                            <div
                              class="price-value flex-column"
                              style="line-height: 18px"
                            >
                              <span
                                >{{ item.currencyCode }}
                                {{
                                  $currencyFormat(
                                    item.currencyCode,
                                    item.totalFare
                                  )
                                }}
                              </span>
                              <span
                                class="local-currency --grey45"
                                v-if="
                                  hasConversionRate &&
                                  !checkSameCurrencyCode(item.currencyCode)
                                "
                                >{{ conversionRate.currency }}
                                {{
                                  $currencyFormat(
                                    conversionRate.currency,
                                    getLocalCurrency(item.totalFare)
                                  )
                                }}
                              </span>
                            </div>
                            <a
                              class="btn btn-primary"
                              type="submit"
                              @click="selectVehicle(item)"
                            >
                              Select
                            </a>

                            <!-- <div class="includes-info">
                              <i class="ic-checklist"></i>
                              Includes Fuel, Toll and Parking
                            </div> -->

                            <!-- <div class="includes-info --blue25">
                                  <i class="ic-checklist"></i>
                                  Includes Insurance
                              </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-20" v-if="item.rateTaggings.length > 0">
                      <div class="col-sm-3"></div>
                      <div class="col-sm-9">
                        <span
                          class="badge badge-tagging"
                          v-for="(val, index) in item.rateTaggings"
                          :style="`color: ${val.textColor} !important; background: ${val.backgroundColor} !important`"
                          :key="index"
                          >{{ val.text }}</span
                        >
                      </div>
                    </div>
                    <div class="provider-box hidden">
                      <div class="col-sm-9 plz">
                        <!-- <pre>{{ item.providers.map((provider) => { return provider.name; }) }}</pre> -->
                        <!-- <div class="provider-img pull-left">
                          <img :src="item.providers[0].imageUri" alt />
                        </div>
                        <div class="pull-left">
                          <div class="provider-name">
                            {{ item.providers[0].name }}
                          </div>
                          <button
                            class="btn btn-info"
                            data-toggle="modal"
                            data-target="#terms-modal"
                          >
                            Rental Terms
                          </button>
                        </div> -->
                      </div>
                      <!-- /.col-sm-7 -->

                      <div class="col-sm-3 prz text-right">
                        <a
                          class="btn btn-primary"
                          type="submit"
                          @click="selectVehicle(item)"
                        >
                          Select
                        </a>
                      </div>
                      <!-- /.col-sm-5-->
                    </div>
                  </div>
                </li>
              </ul>
              <!-- End: Vehicle -->
            </div>
            <div
              class="includes-info"
              style="font-size: 0.8rem"
              v-if="!isLoading && countVehicle"
            >
              <ul style="list-style-type: none">
                <li>Quote includes:</li>
                <li class="img-watch">
                  60 minutes complimentary wait time (international arrivals)
                  for airport pick-ups, 15 mins for all others
                </li>
                <li class="img-meet">
                  Airport Meet & Greet (available as an extra service for
                  minibus and coach)
                </li>
                <!-- <li class="img-meet">Meet &amp; Greet</li> -->
                <li class="img-time">
                  Free cancellation up until 24 hours before pick-up time
                </li>
              </ul>
            </div>
            <!-- End: Availability -->
          </div>
        </div>

        <div class="row" v-if="!isLoading && !countVehicle">
          <NoTransportationAvailable />
        </div>
      </div>
    </section>
    <!-- End: Content -->

    <!-- Start: Modal -->
    <div class="modal fade modal-dark" role="dialog" id="modifySearch__modal">
      <div class="modal-dialog modal-lg main__search">
        <div class="modal-content">
          <div class="modal-body">
            <transferForm
              :mode="searchParameter.mode"
              @closeModal="handleCloseModifySearch()"
            />
          </div>
        </div>
      </div>
    </div>

    <confirmModal
      :header="'Still looking for a car?'"
      :content="'We recommend refreshing your results to see up-to-date prices for your search.'"
      :submit-label="'Refresh'"
      @submit="refresh"
    />
    <!-- End: Modal -->
  </div>
</template>

<script>
import _ from "lodash";
import NoTransportationAvailable from "@/components/shared/NoTransportationAvailable";
import confirmModal from "@/components/shared/ConfirmModal";
import transferForm from "@/components/availability/form/Transfer";
import inquiryAvailabilityService from "@/services/shop/availability/inquiryAvailabilityService.js";
import maverickAutoComplete from "@/plugins/google/autocomplete.js";
import availabilityFilter from "@/plugins/availabilityFilter.js";
import { convertFromMarketFx } from "@/helpers/numberHelper.js";
import { Currencies } from "@/models/constants";
import companyService from "@/services/master/company/companyService.js";

export default {
  components: {
    confirmModal,
    transferForm,
    NoTransportationAvailable,
  },
  data() {
    return {
      autocomplete: null,
      correlationId: null,
      items: [],
      conversionRate: null,
      isLoading: false,
      pickUpDateTime: { offsetName: null },
      searchParameter: { mode: "" },
      transferDistance: null,
      isInquiry: true,
      filter: {
        classes: [],
        specs: [],
        brands: [],
        sort: [],
        defaultSort: null,
      },
      filterHelper: null,
      refreshTimer: null,
      services: {},
      companies: [],
    };
  },
  computed: {
    hasConversionRate() {
      return this.conversionRate && this.conversionRate !== null;
    },
    pickUpLocation: function () {
      return this.searchParameter.pickUpLocation.address
        ? this.searchParameter.pickUpLocation.address.split(",")[0]
        : "";
    },
    dropOffLocation: function () {
      return this.searchParameter.dropOffLocation &&
        this.searchParameter.dropOffLocation.address
        ? this.searchParameter.dropOffLocation.address.split(",")[0]
        : "Same Location";
    },
    shortStartRentDate: function () {
      return this.$helper.toDateString(
        this.searchParameter.pickUpDateTime,
        "D MMM"
      );
    },
    shortEndRentDate: function () {
      return this.$helper.toDateString(
        this.searchParameter.pickUpDateTime,
        "D MMM"
      );
    },
    shortStartRentTime: function () {
      return this.$helper.toDateString(
        this.searchParameter.pickUpDateTime,
        "h:mm A"
      );
    },
    shortEndRentTime: function () {
      return this.$helper.toDateString(
        this.searchParameter.pickUpDateTime,
        "h:mm A"
      );
    },
    longStartRentDate: function () {
      return this.$helper.toDateString(
        this.searchParameter.pickUpDateTime,
        "ddd, D MMM yyyy"
      );
    },
    longEndRentDate: function () {
      return this.$helper.toDateString(
        this.searchParameter.pickUpDateTime,
        "ddd, D MMM yyyy"
      );
    },
    countVehicle: function () {
      return this.items.length;
    },
    cdn: function () {
      return process.env.VUE_APP_CDN;
    },
  },
  async created() {
    this.$helper.scrollTop();
    // subscribe message
    this.$eventBus.$on("executeModifySearch", (newQuery) => {
      $("#modifySearch__modal").modal("hide");
      this.getAvailabilities(newQuery);
      this.$router.replace({ query: newQuery });
    });
    await this.getAvailabilities(this.$route.query);
    const { services } = await this.$store.dispatch("user/getProfile");
    this.services = services;
    this.getAllCompanies();
  },
  beforeDestroy() {
    this.$eventBus.$off("executeModifySearch");
    // unsubcribe partialview's eventbus
    this.$eventBus.$off("bindAirportTransfer");
  },
  mounted() {
    // creates map instance
    this.autocomplete = new maverickAutoComplete();
  },
  methods: {
    async getAllCompanies() {
      this.companies = await companyService.getAllActive();
    },
    checkSameCurrencyCode(currencyCode) {
      const conversionRateCurrency =
        this.conversionRate && this.conversionRate.currency;
      return _.isEqual(conversionRateCurrency, currencyCode);
    },
    getLocalCurrency(originalCurrency) {
      return convertFromMarketFx(
        originalCurrency,
        this.conversionRate.conversionRate,
        this.conversionRate.conversionFormula
      );
    },
    onClickModifySearch() {
      // publish message
      this.$eventBus.$emit(
        "bindAirportTransfer",
        this.searchParameter,
        this.services,
        this.companies,
        true
      );
      $("#modifySearch__modal").modal({ backdrop: "static", keyboard: false });
      $("#modifySearch__modal").css("overflow-y", "auto");
    },
    handleCloseModifySearch() {
      $("#modifySearch__modal").modal("hide");
    },
    initRefreshTimer() {
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
      }
      this.refreshTimer = setTimeout(() => {
        $("#modifySearch__modal").modal("hide");
        $("#confirmmodal").modal({ backdrop: "static", keyboard: false });
      }, this.$helper.fromMinutestoMilliseconds(29));
    },
    async refresh() {
      await this.getAvailabilities(this.$route.query);
    },
    async getAvailabilities(query) {
      try {
        this.isLoading = true;
        // missing URL parameters
        if (this.$helper.isEmpty(query)) {
          this.$helper.redirectToServerError(this);
          return;
        }
        // missing operation type on URL
        if (!query.svc) {
          this.$helper.redirectToServerError(this);
          return;
        }
        this.searchParameter = {
          pickUpLocation: {
            latitude: parseFloat(query.plt),
            longitude: parseFloat(query.plg),
            code: query.pcd,
            name: query.pnm,
            address: query.pad,
            country: query.pcn,
            isAirportZone:
              typeof query.pia === "boolean" ? query.pia : query.pia == "true",
          },
          dropOffLocation: {
            latitude: parseFloat(query.dlt),
            longitude: parseFloat(query.dlg),
            code: query.dcd,
            name: query.dnm,
            address: query.dad,
            country: query.dcn,
            isAirportZone:
              typeof query.dia === "boolean" ? query.dia : query.dia == "true",
          },
          pickUpDateTime: this.$helper.toMaverickDateTime(query.ptm),
          mode: query.mode,
          companyId: query.company || null,
        };

        // get availabilities from API
        const response = await inquiryAvailabilityService.searchVehicleAirport(
          this.searchParameter
        );

        this.conversionRate = response.conversionRate;
        this.pickUpDateTime = response.pickUpDateTime;
        this.correlationId = response.correlationId;
        this.items = response.vehicles;
        this.transferDistance = response.stringDistance;

        this.filterHelper = new availabilityFilter();
        const filterResult = this.filterHelper.populate(this.items);
        this.filter.classes = filterResult.classes;
        this.filter.specs = filterResult.specs;
        this.filter.brands = filterResult.brands;
        this.filter.sort = filterResult.sort;
        this.filter.defaultSort = filterResult.sort[0].value;

        this.initRefreshTimer();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async selectVehicle(vehicle) {
      const payload = {
        correlationId: this.correlationId,
        serviceType: "airporttransfer",
        selectorId: vehicle.selectorId,
      };

      try {
        this.isLoading = true;
        const response = await inquiryAvailabilityService.selectVehicle(
          payload
        );
        this.$router.push({
          name: "InquiryReservationForm",
          params: { id: response },
        });
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    onChangeApplyFilter(item, selector) {
      this.items = this.filterHelper.applyFilter(
        item,
        selector,
        this.filter.defaultSort
      );
      const searchResultHeader = document.querySelector(".car-result-header");
      if (searchResultHeader) {
        this.$nextTick(() =>
          searchResultHeader.scrollIntoView({ behavior: "smooth" })
        );
      }
    },
    onClickApplySort(item) {
      return this.filterHelper.applySort(this.items, item.value);
    },
    onClickFilterReset() {
      this.items = this.filterHelper.reset();
      this.filter.defaultSort = this.filter.sort[0].value;
      for (let i = 0; i < this.filter.classes.length; i++) {
        this.filter.classes[i].isSelected = false;
        this.filter.classes[i].isEnable = true;
      }
      for (let i = 0; i < this.filter.specs.length; i++) {
        this.filter.specs[i].isSelected = false;
        this.filter.specs[i].isEnable = true;
      }
      for (let i = 0; i < this.filter.brands.length; i++) {
        this.filter.brands[i].isSelected = false;
        this.filter.brands[i].isEnable = true;
      }
    },
  },
};
</script>
<style scoped>
.li-info-availability {
  list-style-type: "\002A";
  margin-left: 8px;
  color: #888 !important;
}
.availability-link {
  color: #2e86ab;
}
</style>



// WEBPACK FOOTER //
// src/components/availability/result/inquiry/ResultTransfer.vue